import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DreAgrupada } from '../api/dto/dre-agrupada';

@Injectable({
  providedIn: 'root'
})
export class DreService {

  private url: string = UrlServidor.URL_BASE + 'dre/';

  constructor(private http: HttpClient) { }

  listarDreDetalhada(ano: number, mes: number, baseDre: string): Observable<DreAgrupada[]> {
    let params = new HttpParams()
      .set('ano', ano)
      .set('mes', mes)
      .set('baseDre', baseDre);

    return this.http.get<DreAgrupada[]>(`${this.url}detalhada`, { params: params } );
  }


  gerarRelatorioDre(ano: number) {

    return this.http.get(this.url + 'relatorio/' + ano, {
      responseType: 'blob',
      headers: { 'Accept': 'application/pdf' }
    });
  }

}
